var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    stroke: "currentColor",
    fill: "#3B4858",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.5C0.5 13.0523 0.947715 13.5 1.5 13.5H20.5C21.0523 13.5 21.5 13.0523 21.5 12.5V12.3333C21.5 11.781 21.0523 11.3333 20.5 11.3333H1.5C0.947715 11.3333 0.5 11.781 0.5 12.3333V12.5ZM0.5 7.08333C0.5 7.63562 0.947715 8.08333 1.5 8.08333H20.5C21.0523 8.08333 21.5 7.63562 21.5 7.08333V6.91667C21.5 6.36438 21.0523 5.91667 20.5 5.91667H1.5C0.947715 5.91667 0.5 6.36438 0.5 6.91667V7.08333ZM1.5 0.5C0.947715 0.5 0.5 0.947715 0.5 1.5V1.66667C0.5 2.21895 0.947715 2.66667 1.5 2.66667H20.5C21.0523 2.66667 21.5 2.21895 21.5 1.66667V1.5C21.5 0.947715 21.0523 0.5 20.5 0.5H1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBurger);
export default __webpack_public_path__ + "static/media/menu-burger.ef7ec5e62da2a5b718e6f7ab15e517c5.svg";
export { ForwardRef as ReactComponent };